<div class='flex-header'>
    <page-header pageTitle='Free/Reduced Meal Application'></page-header>
</div>
<div class='flex-content'>
    <div class="summaryRow">
        <div class="frmaStudentSummary">
            <free-reduced-meal-app-student-status [yearId]="yearId"></free-reduced-meal-app-student-status>
        </div>
        <div class="frmaYearDropdown">
            <div translate style="padding-top: 20px; padding-right: 5px;">Academic Year - </div>
            <tyl-form-field label=''>
                <mat-select id='ddlFRMASelectedYear' [(ngModel)]='yearId' name='FRMASelectedYear' (selectionChange)="yearChange(null)">
                    <mat-option *ngFor='let year of years' [value]='year.Id'>{{year.Description}}</mat-option>
                </mat-select>
            </tyl-form-field>
        </div>
    </div>
    <ng-container *ngIf="selectedFamily.UserCanSeeAllStudents">
        <div *ngIf="showNoAppsMessage" style="text-align: center;" translate>No applications have been submitted for this year.</div>
        <div *ngIf="showCurrentStatusMessage" style="text-align: center;padding-bottom:10px;" class="errorRed" translate>Current Status will not update until submission has been accepted.</div>
    </ng-container>
    <div *ngIf="!selectedFamily.UserCanSeeAllStudents" translate style="text-align: center;">Because you are not associated with all the students in this household <br/> in the selected Academic Year, this page is not available.</div>
    <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf" *ngIf="selectedFamily.UserCanSeeAllStudents">
        <mat-table #table [dataSource]="dataSource" matSortDisableClear matSort id="tblFRMAParentSummary" matSortActive="CreatedDate" matSortDirection="desc" *ngIf="showGrid" style="overflow:auto;">
        
            <ng-container matColumnDef="CreatedDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span translate>Created</span> 
                    <filter class="mat-filter" [data]="dataSource" columnName="CreatedDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.CreatedDate | date: 'MM/dd/yy'}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="CreatedByName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span translate>Created By</span> 
                    <filter class="mat-filter" [data]="dataSource" columnName="CreatedByName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.CreatedByName}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="SubmittedDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span translate>Submitted</span> 
                    <filter class="mat-filter" [data]="dataSource" columnName="SubmittedDate" dataType="date"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.SubmittedDate | date: 'MM/dd/yy'}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="SubmittedByName">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span translate>Submitted By</span> 
                    <filter class="mat-filter" [data]="dataSource" columnName="SubmittedByName" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.SubmittedByName}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="Status">
                <mat-header-cell *matHeaderCellDef mat-sort-header> <span translate>Status</span> 
                    <filter class="mat-filter" [data]="dataSource" columnName="Status" dataType="string"></filter>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.Status | titlecase | translate}} </mat-cell>
            </ng-container>
        
            <ng-container matColumnDef="Actions">
                <mat-header-cell *matHeaderCellDef> <span translate>Actions</span> </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = dataIndex;">
                    <tyl-mat-menu id="tblFRMAParentSummaryActionMenu{{i}}" image="actions.png" [iconWidth]="30" *ngIf="element.Status != 'submitted' && element.Status != 'accepted' && element.Status != 'deleted'">
                        <button id="editFrma{{i}}" aria-label="Edit Free/Reduced Meal Application" mat-menu-item class="menuItem" (click)="editClick(element)" translate>Edit</button>
                        <mat-divider></mat-divider>
                        <button id="deleteFrma{{i}}" aria-label="Delete Free/Reduced Meal Application" mat-menu-item class="menuItem" (click)="deleteClick(element)" translate>Delete</button>
                    </tyl-mat-menu>
                    <a *ngIf="element.Status == 'submitted' || element.Status == 'accepted'" class="link" id="viewFrma{{i}}" aria-label="View Free/Reduced Meal Application" (click)="viewClick(element)" translate>View</a>
                </mat-cell>
            </ng-container>        
        
            <mat-header-row *matHeaderRowDef="['CreatedDate', 'CreatedByName', 'SubmittedDate', 'SubmittedByName', 'Status', 'Actions']; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: ['CreatedDate', 'CreatedByName', 'SubmittedDate', 'SubmittedByName', 'Status', 'Actions']; let i = renderIndex;" id="tblFRMAParentSummaryDataRow{{i}}"matRipple>
            </mat-row>

        </mat-table>
    </tyl-kendo-pdf-export>
</div>
<div class='flex-footer'>
    <div class='flex-footer-left'>
        <tyl-button image="add.png" disabledImage="Add disabled.png" [disabled]="!selectedFamily.UserCanSeeAllStudents || disableAdd" label="Start New Application" (clickEvent)="newAppClick()"></tyl-button>
    </div>
    <div class='flex-footer-right'>
        
    </div>
</div>